'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _utils = require('../cart/components/utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var smartFormShared = {
    setBasicSmartFormAttributes: function setBasicSmartFormAttributes(smartFormInstance) {
        if (!smartFormInstance) return;

        smartFormShared.setCountryCode(smartFormInstance);
        smartform.all.suggestBox.setZIndex(2000000002);
    },
    getCountryCodeBySelectedDelivery: function getCountryCodeBySelectedDelivery() {
        var selectedDeliveryTypeElement = document.getElementById('selectedDeliveryType');
        if (selectedDeliveryTypeElement) return selectedDeliveryTypeElement.value.toUpperCase();else return _utils2.default.skEnvironment() ? 'SK' : 'CZ';
    },
    setCountryCode: function setCountryCode(smartFormInstance) {
        var countryCode = this.getCountryCodeBySelectedDelivery();
        smartFormInstance.addressControl.setCountry(countryCode);
    },
    // checking presence of SmartForm object - safe and unified - used from multiple places 
    checkSmartForm: function checkSmartForm() {
        var checkGetInstanceIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var checkRebindAllForms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var checkGetInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        if (typeof smartform === 'undefined' || !smartform) return false;

        if (checkGetInstanceIds && typeof smartform.getInstanceIds !== 'function') return false;

        if (checkRebindAllForms && typeof smartform.checkRebindAllForms !== 'function') return false;

        if (checkGetInstance && typeof smartform.getInstance !== 'function') return false;

        return true;
    },
    adjustAddressFieldValue: function adjustAddressFieldValue(event) {
        var originalValue = event.target.value;
        try {
            var newValue = originalValue.trim();
            // for zip validate and eventually remove spaces
            if (event.target.classList.contains('smartform-address-zip')) {
                var result = /[0-9]{2,3}\s?[0-9]{2,3}/.exec(newValue);
                newValue = !result || result.length === 0 ? '' : result.pop().replaceAll(/\s?/g, '');
            }
            return newValue;
        } catch (e) {
            console.error('Error in inputBlur of address field', e);
            return originalValue;
        }
    },
    getTextByEmailValidationCode: function getTextByEmailValidationCode(code) {
        // this validation reads value assigned to global storage by smartform validation 
        // (smartformReact.js registerSfCallbacks - addValidationCallback)
        switch (code) {
            case null:
            case undefined:
            case 'EXISTS':
            case 'UNKNOWN':
                return null;
            default:
                return Resx.Validation.InvalidEmailAddress;
        }
    }
};
exports.default = smartFormShared;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/smartform/smartFormShared.js
// module id = 145
// module chunks = 0 2